// extracted by css-extract-rspack-plugin
export default {"formSubmitButton":"_9777da51"};